<div class="mobile-top-banner" [class.mobile-top-banner--home]="showHomeImages">
    <div class="large-wrapper mobile-top-banner-wrapper" *ngIf="showBackButton">
        <ion-icon
                name="arrow-back-outline"
                type="button"
                class="mobile-top-banner-back"
                (click)="goBack()"
        >
        </ion-icon>
    </div>
    <ng-container *ngIf="showHomeImages">
        <img src="assets/images/mobile-header-clouds.png" class="mobile-top-banner-clouds" alt="">
        <div class="mobile-home-actions">
            <div class="notification-bell-wrapper" *ngIf="userService.isLoggedIn" (click)="goToNotifications()">
                <ion-icon name="notifications-outline" class="notification-bell-icon"></ion-icon>
                <ion-badge *ngIf="notificationBadgeCount > 0" color="danger" class="notification-badge">
                    {{ notificationBadgeCount > 99 ? '99+' : notificationBadgeCount }}
                </ion-badge>
            </div>
        </div>
        <img
                src="assets/images/logo-image.png"
                class="mobile-top-banner-logo pointer"
                alt=""
                (click)="goHome()">
        <div class="mss-main-toolbar-action__icon" (click)="goToAccount()">
            <img alt="MySupportSpace Profile" src="assets/icons/profile_icon.png">
        </div>
    </ng-container>
</div>